<mat-card appearance="outlined" class="template-canvas">
  <mat-card-content>
    <div class="template-canvas-content-area">
      <rc-template-canvas-region
        name="header"
        [columns]="3"
        [region]="regionHeader"
        (regionChange)="onRegionChanged(regionHeader)"
        [allowedFieldCategories]="regionHeaderFields"
      >
      </rc-template-canvas-region>
      <rc-template-canvas-region
        name="typeData"
        [columns]="3"
        [region]="regionMain"
        (regionChange)="onRegionChanged(regionMain)"
        [allowedFieldCategories]="regionMainFields"
      >
      </rc-template-canvas-region>
      <rc-template-canvas-region
        name="Measurement"
        [columns]="2"
        [region]="regionData"
        (regionChange)="onRegionChanged(regionData)"
        [allowedFieldCategories]="regionDataFields"
      >
      </rc-template-canvas-region>
      <rc-template-canvas-region
        name="footer"
        [columns]="3"
        [region]="regionFooter"
        (regionChange)="onRegionChanged(regionFooter)"
        [allowedFieldCategories]="regionFooterFields"
      >
      </rc-template-canvas-region>
    </div>
  </mat-card-content>
</mat-card>
